import { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";

const AuthenticatedContext = createContext([]);

const AuthenticatedProvider = ({ children }) => {
  const navigation = useNavigate();
  return <>{localStorage.length == 0 ? navigation("/authentication/sign-in") : children}</>;
};

const useAuthenticated = () => {
  const context = useContext(AuthenticatedContext);
  if (!context) {
    throw new Error("useAuthenticated must be used within a AuthenticatedProvider");
  }
  return context;
};

export { AuthenticatedProvider, useAuthenticated };

AuthenticatedProvider.propTypes = {
  children: PropTypes.element,
};
